<!--
 * @Author: your name
 * @Date: 2021-07-19 11:09:33
 * @LastEditTime: 2021-08-24 15:14:08
 * @LastEditors: Please set LastEditors
 * @Description: 页面左右两侧的面板
 * @FilePath: \contingency-manage\src\components\global\XFrame.vue
-->
<template>
  <div
    class="MyFrame"
    :class="{
      myFrameLeft: type == 'left',
      myFrameright: type == 'right',
      defaultFrame: type == '',
    }"
    :style="frameStyle"
  >
    <x-title :icon="titleIcon" v-if="title">
      {{ title }}
    </x-title>
    <slot name="sidebar"></slot>
    <div class="openIconFrame" @click="clickOpen" v-if="isShowOpenIcon">
      <i
        :class="[
          'iconfont',
          openState ? 'icon-xiangzuojiantou' : 'icon-xiangyoujiantou',
        ]"
      ></i>
    </div>
    <div class="openBtnFrame" v-if="isShowOpenBtn" @click="clickOpen">
      <div class="box">
        <i class="iconfont icon-jiantou_zuoyouqiehuan"></i>
      </div>
      <span class="text">{{ `${openState ? "收起" : "展开"}面板` }}</span>
    </div>
    <div
      class="MyFrame-content"
      :class="contentClass"
      :style="{ height: `calc(100% - ${title ? 36 : 0}px)` }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  computed,
  toRefs,
  inject,
  onMounted,
  onBeforeUnmount,
  watch,
} from "vue";
// import { createContext, useContext } from "@/hooks/core/useContext.js";

export default defineComponent({
  name: "HbFrame",
  props: {
    width: {
      type: String,
      default: "420px",
    },
    height: {
      type: String,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    isShowOpenIcon: {
      type: Boolean,
      default: false,
    },
    isShowOpenBtn: {
      type: Boolean,
      default: true,
    },
    // 设置默认展开状态
    defaultOpen: {
      type: Boolean,
      default: true,
    },
    // left || right
    type: {
      type: String,
      default: "",
    },
    contentClass: String,
    title: String,
    titleIcon: String,
  },
  emits: ["update:defaultOpen"],
  setup(props, context) {
    const data = reactive({
      openState: true,
    });
    const refData = toRefs(data);
    const frameStyle = computed(() => {
      const style = {
        width: props.width,
        height: props.height,
        translateX: "",
      };
      if (props.bottom) {
        style.top = "auto";
        style.bottom = "0";
      }
      if (!data.openState) {
        style.transform =
          props.type === "left"
            ? `translateX(calc(-${props.width} + 10px))`
            : `translateX(calc(${props.width} - 10px))`;
      }
      return style;
    });

    const setDefaultOpen = (v) => {
      data.openState = v;
    };
    // const { setData } = useContext('myMapEvent');
    const myMapData = inject("myMapData", {});

    const setFrameOpenFn = (v) => {
      if (props.type === "right") {
        // setData('frameRightOpen', v);
      }
      if (props.type === "left") {
        // setData('frameLeftOpen', v);
      }
    };
    const clickOpen = () => {
      const status = !data.openState;
      setDefaultOpen(status);
      setFrameOpenFn(status);
    };
    // 监听
    watch(
      () => myMapData.frameRightOpen,
      (v) => {
        if (props.type === "right") {
          setDefaultOpen(v);
        }
      }
    );
    watch(
      () => myMapData.frameLeftOpen,
      (v) => {
        if (props.type === "left") {
          setDefaultOpen(v);
        }
      }
    );
    watch(
      () => props.defaultOpen,
      (v) => {
        data.openState = v;
      }
    );
    watch(
      () => data.openState,
      (v) => {
        setFrameOpenFn(v);
        context.emit("update:defaultOpen", v);
      }
    );
    onMounted(() => {
      setFrameOpenFn(true);
    });
    // 在卸载组件实例之前的生命钩子
    onBeforeUnmount(() => {
      // 设置右侧面板隐藏
      if (props.type === "right") {
        // setData('frameRightOpen', false);
      }
      if (props.type === "left") {
        // setData('frameLeftOpen', false);
      }
    });
    return { ...refData, frameStyle, clickOpen };
  },
});
</script>
<style lang="scss" scoped>
.MyFrame {
  width: 100%;
  height: 100%;
  pointer-events: auto;
  box-sizing: border-box;
  position: absolute;
  z-index: 4;
  font-size: 18px;
  transition: all 0.5s;
  background: #fff;
  // background-image: url("~@/assets/images/home/bg.png");
  background-size: 100% 100%;
  // margin-top: 10px;
  pointer-events: auto;
  $bgColor1: rgba(
    $color: #0d427d,
    $alpha: 0.8,
  );
  $bgColor2: rgba(
    $color: #10213c,
    $alpha: 0.8,
  );
  .openIconFrame {
    position: absolute;
    bottom: 50%;
    // height: 40px;
    right: -27px;
    width: 27px;
    height: 65px;
    background-color: #fff;
    color: #a9cedb;
    cursor: pointer;
    padding: 5px;
    // border: 1px solid #ccc;
    border-radius: 2px;
    z-index: 2;
    @include flex-col-c-c;
    // background: url("~@/assets/images/home/icon.png") no-repeat;
    // background-size: 100% 100%;
  }
  .openBtnFrame {
    position: absolute;
    bottom: 5vh;
    // height: 40px;
    width: 40px;
    background-color: #fff;
    color: #a9cedb;
    cursor: pointer;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 2px;
    z-index: 2;
    @include flex-col-c-c;
    .text {
      writing-mode: vertical-lr;
      display: inline-block;
      padding-bottom: 10px;
    }
    .box {
      // // border-color: rgba(67, 101, 167, 0.6);
      // border-width: 2px;
      // border-style: solid;
      border-radius: 2px;
    }
    .iconfont {
      display: inline-block;
      font-size: 30px;
    }
  }
  &.myFrameLeft {
    transform-origin: 0 0;
    animation: leftBox 0.5s;
    position: absolute;
    left: 0;
    .openBtnFrame {
      border-left: 0;
      left: calc(100% - 0px);
    }
  }
  &.myFrameright {
    animation: rightBox 0.5s;
    transform-origin: right 0;
    position: absolute;
    right: 0;
    .openBtnFrame {
      border-right: 0;
      right: calc(100% - 0px);
    }
  }
  .MyFrame-content {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    // background-color: $bgColor1;
    &.flex {
      display: flex;
      flex-direction: column;
    }
  }
}
@keyframes leftBox {
  0% {
    // transform: scaleX(0);
    transform: translate(-710px, 0px);
  }
  100% {
    // transform: scaleX(1);
    transform: translate(0, 0);
  }
}

@keyframes rightBox {
  0% {
    // transform: scaleX(0);
    transform: translate(710px, 0px);
  }
  100% {
    // transform: scaleX(1);
    transform: translate(0, 0);
  }
}
</style>
